import { useEffect } from 'react';

const SITE_URL = 'https://www.urbanfyzio.cz';
const DEFAULT_OG_IMAGE = `${SITE_URL}/icon.png`;

const setMeta = (selector, attr, value) => {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement('meta');
        const [, key] = selector.match(/\[(.+?)=/) || [];
        const [, name] = selector.match(/="(.+?)"\]/) || [];
        if (key && name) el.setAttribute(key, name);
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
    }
    el.setAttribute('href', href);
};

/**
 * Sets <title>, description, canonical, and Open Graph tags for the current route.
 * Lightweight alternative to react-helmet — runs on mount and route change.
 */
const useSEO = ({ title, description, path = '/', image = DEFAULT_OG_IMAGE }) => {
    useEffect(() => {
        const url = `${SITE_URL}${path}`;

        if (title) document.title = title;

        if (description) {
            setMeta('meta[name="description"]', 'content', description);
            setMeta('meta[property="og:description"]', 'content', description);
            setMeta('meta[name="twitter:description"]', 'content', description);
        }

        if (title) {
            setMeta('meta[property="og:title"]', 'content', title);
            setMeta('meta[name="twitter:title"]', 'content', title);
        }

        setLink('canonical', url);
        setMeta('meta[property="og:url"]', 'content', url);
        setMeta('meta[property="og:image"]', 'content', image);
        setMeta('meta[name="twitter:image"]', 'content', image);
        setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    }, [title, description, path, image]);
};

export default useSEO;
